import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';

const DatenschutzPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Helmet>
        <title>Datenschutzerklärung – unternehmenbewerten.ch</title>
        <meta name="description" content="Datenschutzerklärung von unternehmenbewerten.ch. Informationen zur Verarbeitung Ihrer Daten gemäss DSG und DSGVO." />
        <link rel="canonical" href="https://www.unternehmenbewerten.ch/datenschutz" />
      </Helmet>
      
      <main className="pt-20">
        <section className="py-16 lg:py-24">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            {/* Breadcrumb */}
            <nav className="flex items-center gap-2 text-sm mb-8">
              <Link to="/" className="text-[#5a5d5b] hover:text-[#FF0000] transition-colors">Start</Link>
              <span className="text-[#888b89]">/</span>
              <span className="text-[#FF0000]">Datenschutz</span>
            </nav>

            <h1 className="text-4xl font-bold text-[#1a1c1b] mb-4">Datenschutzerklärung</h1>
            <p className="text-[#5a5d5b] mb-12">Stand: Januar 2025</p>
            
            <div className="prose prose-lg max-w-none space-y-10">
              
              {/* Verantwortliche Stelle */}
              <section>
                <h2 className="text-2xl font-bold text-[#1a1c1b] mb-4">1. Verantwortliche Stelle</h2>
                <p className="text-[#5a5d5b] mb-4">
                  Verantwortlich für die Datenverarbeitung auf dieser Website ist:
                </p>
                <div className="bg-[#f8f9fa] rounded-xl p-6">
                  <p className="font-semibold text-[#1a1c1b]">Schweizer Nachfolge Experten AG</p>
                  <p className="text-[#5a5d5b]">c/o unternehmenbewerten.ch</p>
                  <p className="text-[#5a5d5b]">Löwenstrasse 20</p>
                  <p className="text-[#5a5d5b]">8001 Zürich, Schweiz</p>
                  <p className="text-[#5a5d5b] mt-2">E-Mail: <a href="mailto:info@unternehmenbewerten.ch" className="hover:text-[#FF0000] transition-colors" onClick={() => { if (typeof window !== 'undefined' && window.gtag) { window.gtag('event', 'contact_email_click', { event_category: 'contact', method: 'email' }); } }}>info@unternehmenbewerten.ch</a></p>
                  <p className="text-[#5a5d5b]">Telefon: <a href="tel:+41582205550" className="hover:text-[#FF0000] transition-colors" onClick={() => { if (typeof window !== 'undefined' && window.gtag) { window.gtag('event', 'contact_phone_click', { event_category: 'contact', method: 'phone' }); } }}>+41 58 220 55 50</a></p>
                </div>
              </section>

              {/* Grundsatz */}
              <section>
                <h2 className="text-2xl font-bold text-[#1a1c1b] mb-4">2. Grundsatz</h2>
                <p className="text-[#5a5d5b] mb-4">
                  Der Schutz Ihrer Privatsphäre ist uns ein wichtiges Anliegen. Diese Datenschutzerklärung 
                  informiert Sie über die Art, den Umfang und den Zweck der Erhebung und Verwendung 
                  personenbezogener Daten auf unserer Website unternehmenbewerten.ch gemäss dem 
                  Schweizerischen Datenschutzgesetz (DSG) und der Europäischen Datenschutz-Grundverordnung (DSGVO).
                </p>
                <p className="text-[#5a5d5b]">
                  Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen 
                  Datenschutzvorschriften sowie dieser Datenschutzerklärung.
                </p>
              </section>

              {/* Erhobene Daten */}
              <section>
                <h2 className="text-2xl font-bold text-[#1a1c1b] mb-4">3. Erhobene Daten</h2>
                
                <h3 className="text-xl font-semibold text-[#1a1c1b] mb-3 mt-6">3.1 Automatisch erfasste Daten</h3>
                <p className="text-[#5a5d5b] mb-4">
                  Bei jedem Zugriff auf unsere Website werden automatisch folgende Informationen erfasst:
                </p>
                <ul className="list-disc pl-6 text-[#5a5d5b] space-y-2">
                  <li>IP-Adresse des anfragenden Rechners (anonymisiert)</li>
                  <li>Datum und Uhrzeit des Zugriffs</li>
                  <li>Name und URL der abgerufenen Datei</li>
                  <li>Website, von der aus der Zugriff erfolgt (Referrer-URL)</li>
                  <li>Verwendeter Browser und ggf. das Betriebssystem</li>
                  <li>Name Ihres Internet-Providers</li>
                </ul>
                <p className="text-[#5a5d5b] mt-4">
                  Diese Daten werden ausschliesslich zur Sicherstellung eines störungsfreien Betriebs 
                  und zur Verbesserung unseres Angebots ausgewertet.
                </p>

                <h3 className="text-xl font-semibold text-[#1a1c1b] mb-3 mt-6">3.2 Unternehmensbewertung</h3>
                <p className="text-[#5a5d5b] mb-4">
                  Bei der Nutzung unseres Bewertungstools erheben wir folgende Daten:
                </p>
                <ul className="list-disc pl-6 text-[#5a5d5b] space-y-2">
                  <li>Unternehmensname und Branche</li>
                  <li>Standort des Unternehmens</li>
                  <li>Finanzkennzahlen (Umsatz, EBITDA, Vermögenswerte, Verbindlichkeiten etc.)</li>
                  <li>Qualitative Faktoren zur Unternehmensbewertung</li>
                  <li>Bewertungszweck und Zeitraum</li>
                  <li>Kontaktdaten (Name, E-Mail, Telefon)</li>
                </ul>

                <h3 className="text-xl font-semibold text-[#1a1c1b] mb-3 mt-6">3.3 Kontaktformular</h3>
                <p className="text-[#5a5d5b]">
                  Bei Anfragen über unser Kontaktformular werden Ihre Angaben zur Bearbeitung der 
                  Anfrage und für mögliche Anschlussfragen gespeichert.
                </p>
              </section>

              {/* Zweck der Datenverarbeitung */}
              <section>
                <h2 className="text-2xl font-bold text-[#1a1c1b] mb-4">4. Zweck der Datenverarbeitung</h2>
                <p className="text-[#5a5d5b] mb-4">Wir verwenden die erhobenen Daten für folgende Zwecke:</p>
                <ul className="list-disc pl-6 text-[#5a5d5b] space-y-2">
                  <li>Durchführung der Unternehmensbewertung und Erstellung des Bewertungsberichts</li>
                  <li>Versand des Bewertungsergebnisses per E-Mail</li>
                  <li>Beantwortung von Kontaktanfragen</li>
                  <li>Verbesserung unserer Dienstleistungen</li>
                  <li>Statistische Auswertungen (anonymisiert)</li>
                  <li>Erfüllung rechtlicher Pflichten</li>
                </ul>
              </section>

              {/* Rechtsgrundlage */}
              <section>
                <h2 className="text-2xl font-bold text-[#1a1c1b] mb-4">5. Rechtsgrundlage</h2>
                <p className="text-[#5a5d5b] mb-4">
                  Die Verarbeitung Ihrer Daten erfolgt auf folgenden Rechtsgrundlagen:
                </p>
                <ul className="list-disc pl-6 text-[#5a5d5b] space-y-2">
                  <li><strong>Einwilligung (Art. 6 Abs. 1 lit. a DSGVO):</strong> Sofern Sie uns eine Einwilligung erteilt haben</li>
                  <li><strong>Vertragserfüllung (Art. 6 Abs. 1 lit. b DSGVO):</strong> Für die Durchführung der Bewertungsdienstleistung</li>
                  <li><strong>Berechtigte Interessen (Art. 6 Abs. 1 lit. f DSGVO):</strong> Zur Verbesserung unserer Dienste und Sicherheit</li>
                  <li><strong>Rechtliche Verpflichtung (Art. 6 Abs. 1 lit. c DSGVO):</strong> Zur Erfüllung gesetzlicher Aufbewahrungspflichten</li>
                </ul>
              </section>

              {/* Datenweitergabe */}
              <section>
                <h2 className="text-2xl font-bold text-[#1a1c1b] mb-4">6. Datenweitergabe an Dritte</h2>
                <p className="text-[#5a5d5b] mb-4">
                  Eine Weitergabe Ihrer personenbezogenen Daten an Dritte erfolgt nur:
                </p>
                <ul className="list-disc pl-6 text-[#5a5d5b] space-y-2">
                  <li>Mit Ihrer ausdrücklichen Einwilligung</li>
                  <li>Zur Erfüllung rechtlicher Verpflichtungen</li>
                  <li>An Auftragsverarbeiter, die uns bei der Erbringung unserer Dienste unterstützen (z.B. Hosting-Provider)</li>
                </ul>
                <p className="text-[#5a5d5b] mt-4">
                  <strong>Wir verkaufen Ihre Daten nicht an Dritte.</strong> Alle Auftragsverarbeiter sind 
                  vertraglich zur Einhaltung der Datenschutzbestimmungen verpflichtet.
                </p>
              </section>

              {/* Datensicherheit */}
              <section>
                <h2 className="text-2xl font-bold text-[#1a1c1b] mb-4">7. Datensicherheit</h2>
                <p className="text-[#5a5d5b] mb-4">
                  Wir setzen technische und organisatorische Sicherheitsmassnahmen ein, um Ihre Daten 
                  gegen Manipulation, Verlust, Zerstörung oder Zugriff unberechtigter Personen zu schützen:
                </p>
                <ul className="list-disc pl-6 text-[#5a5d5b] space-y-2">
                  <li>SSL/TLS-Verschlüsselung der Datenübertragung</li>
                  <li>Verschlüsselte Speicherung sensibler Daten</li>
                  <li>Regelmässige Sicherheitsupdates</li>
                  <li>Zugangsbeschränkungen und Passwortschutz</li>
                  <li>Regelmässige Backups</li>
                </ul>
              </section>

              {/* Speicherdauer */}
              <section>
                <h2 className="text-2xl font-bold text-[#1a1c1b] mb-4">8. Speicherdauer</h2>
                <p className="text-[#5a5d5b] mb-4">
                  Wir speichern Ihre personenbezogenen Daten nur so lange, wie es für die jeweiligen 
                  Verarbeitungszwecke erforderlich ist oder gesetzliche Aufbewahrungsfristen bestehen:
                </p>
                <ul className="list-disc pl-6 text-[#5a5d5b] space-y-2">
                  <li><strong>Bewertungsdaten:</strong> 10 Jahre (gesetzliche Aufbewahrungspflicht)</li>
                  <li><strong>Kontaktanfragen:</strong> 3 Jahre nach Abschluss der Kommunikation</li>
                  <li><strong>Server-Logfiles:</strong> 30 Tage</li>
                </ul>
              </section>

              {/* Cookies */}
              <section>
                <h2 className="text-2xl font-bold text-[#1a1c1b] mb-4">9. Cookies</h2>
                <p className="text-[#5a5d5b] mb-4">
                  Unsere Website verwendet Cookies. Diese kleinen Textdateien werden auf Ihrem Endgerät 
                  gespeichert und richten keinen Schaden an.
                </p>
                <h3 className="text-xl font-semibold text-[#1a1c1b] mb-3 mt-6">9.1 Notwendige Cookies</h3>
                <p className="text-[#5a5d5b]">
                  Diese Cookies sind für den Betrieb der Website erforderlich (z.B. Session-Cookies, 
                  Authentifizierung). Sie können nicht deaktiviert werden.
                </p>
                <h3 className="text-xl font-semibold text-[#1a1c1b] mb-3 mt-6">9.2 Analyse-Cookies</h3>
                <p className="text-[#5a5d5b]">
                  Diese Cookies helfen uns, die Nutzung unserer Website zu verstehen und zu verbessern. 
                  Die Daten werden anonymisiert erhoben.
                </p>
              </section>

              {/* Ihre Rechte */}
              <section>
                <h2 className="text-2xl font-bold text-[#1a1c1b] mb-4">10. Ihre Rechte</h2>
                <p className="text-[#5a5d5b] mb-4">Sie haben folgende Rechte bezüglich Ihrer personenbezogenen Daten:</p>
                <ul className="list-disc pl-6 text-[#5a5d5b] space-y-2">
                  <li><strong>Auskunftsrecht:</strong> Sie können Auskunft über Ihre gespeicherten Daten verlangen</li>
                  <li><strong>Berichtigungsrecht:</strong> Sie können die Berichtigung unrichtiger Daten verlangen</li>
                  <li><strong>Löschungsrecht:</strong> Sie können die Löschung Ihrer Daten verlangen, sofern keine gesetzlichen Aufbewahrungspflichten entgegenstehen</li>
                  <li><strong>Einschränkung der Verarbeitung:</strong> Sie können die Einschränkung der Verarbeitung verlangen</li>
                  <li><strong>Datenübertragbarkeit:</strong> Sie können Ihre Daten in einem maschinenlesbaren Format erhalten</li>
                  <li><strong>Widerspruchsrecht:</strong> Sie können der Verarbeitung jederzeit widersprechen</li>
                  <li><strong>Widerruf der Einwilligung:</strong> Eine erteilte Einwilligung können Sie jederzeit widerrufen</li>
                </ul>
                <p className="text-[#5a5d5b] mt-4">
                  Zur Ausübung Ihrer Rechte wenden Sie sich bitte an: info@unternehmenbewerten.ch
                </p>
              </section>

              {/* Beschwerderecht */}
              <section>
                <h2 className="text-2xl font-bold text-[#1a1c1b] mb-4">11. Beschwerderecht</h2>
                <p className="text-[#5a5d5b]">
                  Sie haben das Recht, sich bei einer Datenschutz-Aufsichtsbehörde zu beschweren. 
                  In der Schweiz ist dies der Eidgenössische Datenschutz- und Öffentlichkeitsbeauftragte (EDÖB).
                </p>
              </section>

              {/* Änderungen */}
              <section>
                <h2 className="text-2xl font-bold text-[#1a1c1b] mb-4">12. Änderungen dieser Datenschutzerklärung</h2>
                <p className="text-[#5a5d5b]">
                  Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie stets den 
                  aktuellen rechtlichen Anforderungen entspricht oder um Änderungen unserer Leistungen 
                  umzusetzen. Für Ihren erneuten Besuch gilt dann die neue Datenschutzerklärung.
                </p>
              </section>

            </div>
          </div>
        </section>
      </main>
      
      <Footer />
    </div>
  );
};

export default DatenschutzPage;
